// session-name.js — fills the demo "session" labels with a name that matches the
// visitor's own day and time, so the caller card reads "Friday Night Bingo" for a
// host opening it on Friday evening. Specific-over-generic (PRODUCT.md): a real day
// beats a frozen "Tuesday." Targets any [data-session-day] element; uses the
// browser's locale + timezone, so it's correct wherever the visitor is.

(function () {
  'use strict';

  function periodFor(hour) {
    if (hour >= 5 && hour < 12) return 'Morning';   // 5:00am – 11:59am
    if (hour >= 12 && hour < 17) return 'Afternoon'; // 12:00pm – 4:59pm
    return 'Night';                                  // 5:00pm – 4:59am
  }

  function sessionLabel() {
    var now = new Date();
    var weekday;
    try {
      weekday = now.toLocaleDateString(undefined, { weekday: 'long' });
    } catch (e) {
      weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][now.getDay()];
    }
    return weekday + ' ' + periodFor(now.getHours()) + ' Bingo';
  }

  function apply() {
    var label = sessionLabel();
    document.querySelectorAll('[data-session-day]').forEach(function (el) {
      el.textContent = label;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
